import React from "react";
import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SHeaderCell = styled.div<React.HTMLAttributes<HTMLDivElement> & React.RefAttributes<HTMLDivElement>>`
  ${setFlexDFAIC};
`;
